module.exports = __webpack_public_path__ + "static/media/fast-delivery.b44d7ecb.svg";